module.exports = __webpack_public_path__ + "img/borderLongRadioWhite.8ec2c746.svg";